<template>
    <!--<button @click="newConfiguration()" class="btn my_btn_standard" style="width:100%">{{$t('3249')}}</button>-->
    <div v-if="sapProfile==true" class="ZAfont_family" style="border: 2px solid #ced2d8; padding: 15px; margin-top:15px">
        <div>
            <button v-if="priceInfoSAP==true" @click="changeModalOffer()" class="btn my_btn_standard_blue" style="width:100%;margin-bottom:10px">Preisanzeige</button>
            <div v-if="customerSelection==true" style="width:100%;margin-bottom:10px">
                <input ref="inputCust" v-model="inputCust" list="arrayCustomer" style="width:100%" :placeholder="$t('3357')">
                <datalist id="arrayCustomer" list style="margin-top:10px; width:100%">
                    <option v-for="(customer , index) in arrayCustomer" v-if="customer[0]!=1"> {{index}} | {{customer[0]}} | {{customer[1]}} | {{customer[2]}} | {{customer[3]}} | {{customer[4]}}</option>
                </datalist>
            </div>
            <button @click="get_ZlwCalculation()" class="btn my_btn_standard_blue" style="width:100%;margin-top:10px">TN-Konfig laden</button>
        </div>
        <div v-if="zlwNumber!=null&&suffixSelection.length>0" class="my_color_00338e" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 10px;vertical-align:central">
            <div style="font-size: 1.2em; font-weight:500">Version: </div>
            <div>
                <select v-model="selectedSuffix" class="my_select" style="width:100%">
                    <option v-for="suffix in suffixSelection">{{suffix.value}}</option>
                </select>
            </div>
            <div v-if="selectedSuffix!=null&&selectedSuffix<9">
                <button @click="get_newVersionZlwCalculation()" class="btn my_btn_standard_blue" style="width:100%;">Neue Version</button>
            </div>
        </div>
        <div style="text-align:right; margin-bottom:10px">
            <div class="my_color_00338e">
                <span style="font-size: 1.2em; font-weight:500">{{$t('3332')}}:</span>
                <span v-if="zlwNumber==null||zlwNumber==''" style="font-size: 1.8em; font-weight:900" v-bind:class="{my_text_selection_prevent: showTemplateButton==false}"> {{zlmNumber}}</span>
                <span v-if="zlwNumber!=null&&zlwNumber!=''" style="font-size: 1.8em; font-weight: 900; margin-top:10px" v-bind:class="{my_text_selection_prevent: showTemplateButton==false}">
                    <span> {{zlwNumber}}</span>
                    <span v-if="selectedSuffix!=null">_{{selectedSuffix}}</span>
                </span>
                <input v-model="configuration_Number" class="form-control" />
                <button @click="search_configurationNumber()" class="btn my_btn_standard_blue" style="width:100%;margin-top:10px"> {{$t('1186')}}</button>
                <button v-if="showTemplateButton==true" @click="zlmTemplate()" class="btn my_btn_standard_blue" style="width:100%;margin-top:10px"> Als Vorlage verwenden </button>
            </div>
        </div>
        <div>
            <button @click="change_calculationModifiable()" class="btn my_btn_standard_blue" v-bind:disabled="showTemplateButton==true" style="width:100%;margin-top:10px">{{$t('3606')}}</button>
        </div>
        <hr />
        <div v-if="showPriceButton===true">
            <div style="margin-top:10px">
                <input type="checkbox" v-model="accept_terms_pricing" id="accept_terms_pricing" /> <label style="font-weight:600; font-size:0.9rem; margin-bottom:10px" class="ZAfont_family">{{$t('3468')}}</label>
            </div>
            <button v-if="showPriceButton==true" :disabled="!accept_terms_pricing" @click="change_showInfo()" class="btn my_btn_standard_blue" style="width:100%;margin-top:10px">{{$t('3467')}}</button>
            <hr />
        </div>
        <div v-if="showFileDownload===true">
            <select v-model="fileLanguage" class="my_select" style="width:100%">
                <option v-if="showUnit==false" value="de-DE">{{$t('1015')}}</option>
                <option value="en-GB">{{$t('1014')}}</option>
                <option v-if="showUnit==false" value="es-ES">{{$t('1455')}}</option>
                <option v-if="showUnit==false" value="it-IT">{{$t('1456')}}</option>
                <option v-if="showUnit==false" value="pl-PL">{{$t('1457')}}</option>
                <option v-if="showUnit==false" value="fr-FR">{{$t('1458')}}</option>
                <option v-if="showUnit==false" value="cs-CZ">{{$t('1459')}}</option>
                <option v-if="showUnit==false" value="ru-RU">{{$t('1460')}}</option>
                <option v-if="showUnit==false" value="tr-TR">{{$t('1461')}}</option>
                <option v-if="showUnit==false" value="pt-PT">{{$t('1462')}}</option>
                <option v-if="showUnit==false" value="zh">{{$t('1463')}}</option>
            </select>
            <button @click="get_htmlFileContent()" class="btn my_btn_standard" style="margin-top:10px; width:100%"> <span class="fa-solid fa-download"></span><span> {{$t('3463')}}</span></button>
            <hr />
        </div>
        <!--<div>
            <input type="checkbox" v-model="accept_terms_of_request" id="accept_terms_of_request" /> <label style="font-weight:600; font-size:0.9rem; margin-bottom:10px" class="ZAfont_family" for="accept_terms_of_request">{{$t('3370')}}<a v-if="$t('3369') =='de'" v-b-modal="'modal-accept_terms_of_request'" href="/pdf/de/Nutzungsbedingungen-DE.pdf" target="_blank">Anfragebedingungen</a><a v-else v-b-modal="'modal-accept_terms_of_request'" href="/pdf/en/Nutzungsbedingungen-EN.pdf" target="_blank">--><!--href="javascript:void(0)"--><!--Terms of Request</a> </label>
        </div>-->
    <div v-if="accept_request_a_quote==true">
        <div v-if="sapProfile==true && salesOrder!=null && showTemplateButton==true">
            <div>
                <input type="checkbox" v-model="checkMotor" v-bind:disabled="motorAvailable==false" /><label style="margin-left:5px;margin-bottom:10px" class="ZAfont_family">Motor</label>
            </div>
            <div>
                <input type="checkbox" v-model="checkFrame" v-bind:disabled="frameAvailable==false" /><label style="margin-left:5px;margin-bottom:10px" class="ZAfont_family">Rahmen</label>
            </div>
            <div>
                <input type="checkbox" v-model="checkInverter" v-bind:disabled="inverterAvailable==false" /><label style="margin-left:5px;margin-bottom:10px" class="ZAfont_family">Frequenzumrichter</label>
            </div>
            <div>
                <input type="checkbox" v-model="checkEvak" v-bind:disabled="evakAvailable==false" /><label style="margin-left:5px;margin-bottom:10px" class="ZAfont_family">Evakuierung</label>
            </div>
            <div>
                <input type="checkbox" v-model="checkRecuperation" v-bind:disabled="recuperationAvailable==false" /><label style="margin-left:5px;margin-bottom:10px" class="ZAfont_family">Rückspeiseeinheit</label>
            </div>
        </div>
        <div v-if="treibscheibeoffer==true">Treibscheibe nicht vorhanden! Keine Auftragsanlage moeglich! Bitte an die Technik wenden!/traction sheave missing! Unable to create an order! Please contact technical support!</div>
        <div v-if="salesOrder==null">Verbindung zu SAP verloren. Bitte ZAlift schließen und neu öffnen!/Connection to SAP lost. Please close ZAlift and reopen it!</div>
        <button v-if="sapProfile==true && salesOrder!=null && sapclient != '100' && showTemplateButton==true && treibscheibeoffer == false" v-bind:disabled="!request_offer_or_post_sap_available" @click="request_offer_or_post_order_sap('U')" class="btn my_btn_standard_blue" style="width:100%;margin-top:10px"> {{$t('3372')}} <i class="fas fa-chevron-right"></i></button>
        <button v-if="sapProfile==true && salesOrder!=null && sapclient != '100' && showTemplateButton==true" v-bind:disabled="!request_offer_or_post_sap_available" @click="request_Quotation_or_post_Quotation_sap('A')" class="btn my_btn_standard_blue" style="width:100%;margin-top:10px"> {{$t('3371')}} <i class="fas fa-chevron-right"></i></button>
        <button v-if="sapProfile==true && salesOrder!=null && sapclient != '100' && treibscheibeoffer == false && showTemplateButton==true" v-bind:disabled="!request_offer_or_post_sap_available" @click="request_Inquiry_or_post_Inquiry_sap('VCDM')" class="btn my_btn_standard_blue" style="width:100%;margin-top:10px"> OK-VCDM <i class="fas fa-chevron-right"></i></button>

        <button v-if="sapProfile==true && salesOrder!=null && sapclient == '100' && treibscheibeoffer == false && showTemplateButton==true" v-bind:disabled="!request_offer_or_post_sap_available" @click="request_offer_or_post_order_sap('U')" class="btn my_btn_red" style="width:100%;margin-top:10px"> {{$t('3372')}} (!PS-System!) <i class="fas fa-chevron-right"></i></button>
        <button v-if="sapProfile==true && salesOrder!=null && sapclient == '100' && showTemplateButton==true" v-bind:disabled="!request_offer_or_post_sap_available" @click="request_Quotation_or_post_Quotation_sap('A')" class="btn my_btn_red" style="width:100%;margin-top:10px"> {{$t('3371')}} (!PS-System!) <i class="fas fa-chevron-right"></i></button>
        <button v-if="sapProfile==true && salesOrder!=null && sapclient == '100' && treibscheibeoffer == false && showTemplateButton==true" v-bind:disabled="!request_offer_or_post_sap_available" @click="request_Inquiry_or_post_Inquiry_sap('VCDM')" class="btn my_btn_red" style="width:100%;margin-top:10px"> OK-VCDM (!PS-System!) <i class="fas fa-chevron-right"></i></button>
    </div>
        <div class="my_modal" v-bind:class="{show: showModalZlw==true}" align="center">
            <div class="my_modal-dialog" style="height:100px">
                <div class="my_modal-content">
                    <div class="my_modal-header">
                        <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">ZLW-{{$t('1230')}}</div>
                        <div>
                            <span @click="closeModalZlw(false)" class="fal fa-times fa-2x"></span>
                        </div>
                    </div>
                    <div class="my_modal-body" style="width:calc(100vw - 90px)">
                        <div style="margin-bottom: 10px; margin-top: 5px">
                            <div>
                                <input type="file" hidden id="upload-btn" @change="check_configuration_fromFile" accept=".xml" />
                                <label for="upload-btn" class="btn my_btn_standard_blue"> XML {{$t('3330')}}</label>
                            </div>
                        </div>
                        <hr />
                        <div style="margin-top:10px; margin-bottom:10px">
                            <div class="ZAfont_family ZAfont_size" style="margin-bottom:5px">Auslegungsnummer</div>
                            <div class="my_input-group">
                                <input v-model="calculationNumber" v-bind:placeholder="this.$i18n.i18next.t('3173')" class="my_input" style="width: 50%; margin-right: 5px" />
                            </div>
                        </div>
                        <div style="margin-bottom:10px">
                            <div class="ZAfont_family ZAfont_size" style="margin-bottom:5px">{{$t('3587')}}</div>
                            <div class="my_input-group">
                                <input v-model="itemNumber" v-bind:placeholder="this.$i18n.i18next.t('3173')" class="my_input" style="width: 50%; margin-right: 5px" />
                            </div>
                        </div>
                        <div style="margin-bottom:10px">
                            <div class="ZAfont_family ZAfont_size" style="margin-bottom:5px">ATkonf</div>
                            <div class="my_input-group">
                                <input v-model="atkonfNumber" v-bind:placeholder="this.$i18n.i18next.t('3173')" class="my_input" style="width: 50%; margin-right: 5px" />
                            </div>
                        </div>
                        <div style="margin-bottom:10px">
                            <div class="ZAfont_family ZAfont_size" style="margin-bottom:5px">Belegnummer</div>
                            <div class="my_input-group">
                                <input v-model="documentNumber" v-bind:placeholder="this.$i18n.i18next.t('3173')" class="my_input" style="width: 50%; margin-right: 5px" />
                            </div>
                        </div>
                        <div style="margin-bottom: 10px">
                            <button @click="searchCalculation" class="btn my_btn_standard_blue">Suchen</button>
                        </div>
                        <div v-if="loaderExistingConfigurations == true">
                            <div style="display:flex; align-items:center; justify-content:center">
                                <LoaderIcon v-bind:loaderSize="'lg'"></LoaderIcon>
                            </div>
                        </div>
                        <div v-if="loaderExistingConfigurations==false&&calculationInformation==true&&(calculationNumber!=null||itemNumber!=null||atkonfNumber!=null||documentNumber!=nul)&&(atkonfSelection==null||atkonfSelection.length==0)" class="ZAfont_family ZAfont_size" style="text-align:center;margin-top: 20px">{{$t('1509')}}</div>
                        <div v-if="loaderExistingConfigurations==false&&atkonfSelection!=null&&atkonfSelection.length>0" style="margin-top:10px; width:calc(100vw - 100px)">
                            <table class="my_table_suspensionMeans ZAfont_family ZAfont_size">
                                <thead style="height:60px">
                                    <tr style="display:flex; height:100%">
                                        <th style="flex:0 0 15%">ATkonf</th>
                                        <th style="flex:0 0 5%">BEARB</th>
                                        <th style="flex:0 0 5%">BELAEN</th>
                                        <th style="flex:0 0 10%">ZALNUM</th>
                                        <th style="flex:0 0 5%">BELEG</th>
                                        <th style="flex:0 0 5%">GearZ</th>
                                        <th style="flex:0 0 5%">SANUM</th>
                                        <th style="flex:0 0 5%">KID</th>
                                        <th style="flex:0 0 5%">KUNNUM</th>
                                        <th style="flex:0 0 5%">KUNNAM</th>
                                        <th style="flex:0 0 5%">MBG</th>
                                        <th style="flex:0 0 5%">MFE</th>
                                        <th style="flex:0 0 5%">MNr</th>
                                        <th style="flex:0 0 5%">PROJEKT</th>
                                        <th style="flex:0 0 5%">ZLAQ</th>
                                        <th style="flex:0 0 5%">ZLAV</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="atkonf in atkonfSelection" @click="rowClick(atkonf, $event)" style="display:flex">
                                        <td style="flex:0 0 15%; text-align:left">
                                            <span v-if="atkonf.atkonfNumber!=null">{{atkonf.atkonfNumber}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.bearb!=null">{{atkonf.bearb}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.belaen!=null">{{atkonf.belaen}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 10%; text-align:left">
                                            <span v-if="atkonf.configurationNumber!=null">{{atkonf.configurationNumber}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.documentNumber!=null">{{atkonf.documentNumber}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.gearZ!=null">{{atkonf.gearZ}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.itemNumber!=null">{{atkonf.itemNumber}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.kid!=null">{{atkonf.kid}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.kunnum!=null">{{atkonf.kunnum}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.kunnam!=null">{{atkonf.kunnam}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.mbg!=null">{{atkonf.mbg}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.mfe!=null">{{atkonf.mfe}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.mnr!=null">{{atkonf.mnr}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.projekt!=null">{{atkonf.projekt}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.zlaq!=null">{{atkonf.zlaq}}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td style="flex:0 0 5%; text-align:left">
                                            <span v-if="atkonf.zlav!=null">{{atkonf.zlav}}</span>
                                            <span v-else>-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="my_modal-footer" style="justify-content:flex-end">
                        <div>
                            <button @click="closeModalZlw(false)" class="btn my_btn_standard" style="margin-right:5px">{{$t('3237')}}</button>
                            <!--<button @click="closeModalZlw(true)" class="btn my_btn_standard">{{$t('1023')}}</button>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '../../../router';
    import axios from 'axios';
    import Images from '../../configuration/Images';
    import LoaderIcon from '../../loader/LoaderIcon';
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';

    export default {
        name: 'SummaryInformationManual',
        components: {
            Images,
            InvalidityReasons,
            LoaderIcon,
        },
        props: {
            additional: false,
        },
        data() {
            return {
                accept_terms_of_request: false,
                accept_terms_pricing: false,
                showModal: false,
                scrollYPosition: 0,
                configuration_Number: null,
                zlw_Number: null,
                calculation_Number: null,
                atkonf_Number: null,
                item_Number: null,
                document_Number: null,
                calculationInformation: false,
                check_Motor: null,
                check_Frame: null,
                check_Inverter: null,
                check_Evak: null,
                check_Recuperation: null,
                arrayCustomer: [],
                inputCust: '',
                arrCust: [],
            }
        },
        watch: {
            async inputCust(val, oldVal) {
                if (val != oldVal && val.length >= 4 && val.length < 20) {
                    await axios({
                        method: 'post',
                        url: '/api/summaries/search_for_customers/' + this.inputCust
                    })
                        .then((response) => {
                            this.arrayCustomer = response.data.map(f => {
                                const accountnumber1 = f["accountnumber1"] != null ? f["accountnumber1"] : '';
                                const name = f["name"] != null ? f["name"] : '';
                                const companynumber = f["companynumber"] != null ? f["companynumber"] : '';
                                const accountnumber2 = f["accountnumber2"] != null ? f["accountnumber2"] : '';
                                const accountnumber = f["accountnumber"] != null ? f["accountnumber"] : '';
                                return [accountnumber2, name, companynumber, accountnumber1, accountnumber];
                            })
                        })
                } else {
                    if (val.length < 4) {
                        this.arrayCustomer = [];
                    }
                }
            }
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            salesOrder: {
                get() {
                    return this.$store.state.configurations.salesOrder
                }
            },

            sapclient: {
                get() {
                    return this.$store.state.user.sapclient
                }
            },
            priceInfoSAP: {
                get() {
                    return false;
                }
            },
            customerSelection: {
                get() {
                    return this.priceInfoSAP == true && (this.$store.state.configurations.customer == null || this.$store.state.configurations.customer == '');
                }
            },
            motorManualDataSelected: {
                get() {
                    if (this.$store.state.inputsManual.motorManualData != null && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details') && this.$store.state.inputsManual.motorManualData.details.hasOwnProperty('mN_MOT')) {
                        return this.$store.state.inputsManual.motorManualData;
                    }
                    return null;
                }
            },
            treibscheibeoffer: {
                get() {
                    if (this.motorManualDataSelected != null) {
                        if (this.motorManualDataSelected.details.mN_TS == 'Angebot/Offer')
                        return true
                    }
                    return false
                }
            },

            showTemplateButton: {
                get() {
                    return this.$store.state.manualHome.showTemplateButton;
                }
            },
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                }
            },
            showPriceButton: {
                get() {
                    return false;
                },
            },
            accept_request_a_quote: {
                get() {
                    this.$store.dispatch('user/get_userSapClient_Informations_storeAction')
                    return true;
                },
            },
            zAlift_ID: {
                get() {

                    var suffix = null;
                    if (this.additional == true && this.$store.state.summary.summary != null && this.$store.state.summary.summary.hasOwnProperty('suffixData') && this.$store.state.summary.summary.suffixData != null) {
                        const firstIndex_whichMeetCondition = this.$store.state.summary.summary.suffixData.findIndex(i => i.selected == true);
                        if (firstIndex_whichMeetCondition > -1) {
                            suffix = this.$store.state.summary.summary.suffixData[firstIndex_whichMeetCondition].suffix;
                        }
                    }

                    if (suffix == null) {
                        return this.$store.state.summary.summary.zAlift_ID;
                    }
                    else {
                        return this.$store.state.summary.summary.zAlift_ID + "_V" + suffix;
                    }

                },
            },
            zlmNumber: {
                get() {
                    if (this.$store.state.manualHome.configNumberZLM != undefined && this.$store.state.manualHome.configNumberZLM != null && this.$store.state.manualHome.configNumberZLM != '') {
                        const configNumberZLM = "ZLM-" + this.$store.state.manualHome.configNumberZLM;
                        return configNumberZLM;
                    }
                    else {
                        return null;
                    }
                },
            },
            configurationNumber: {
                get() {
                    return this.configuration_Number;
                },
                set(value) {
                    this.configuration_Number = value
                }
            },
            zlwNumber: {
                get() {
                    return this.$store.state.manualHome.zlwNumber;
                },
                set(value) {
                    this.zlw_Number = value;
                }
            },
            showModalZlw: {
                get() {
                    return this.$store.state.manualHome.showModalZlw;
                }
            },
            showTemplateButton: {
                get() {
                    return this.$store.state.manualHome.showTemplateButton;
                }
            },
            suffixSelection: {
                get() {
                    if (this.$store.state.manualHome.suffixSelection != null && this.$store.state.manualHome.suffixSelection.length > 0) {
                        return this.$store.state.manualHome.suffixSelection;
                    }
                    else {
                        return [];
                    }
                },
            },

            selectedSuffix: {
                get() {
                    if (this.$store.state.manualHome.suffixSelection != null && this.$store.state.manualHome.suffixSelection.length > 0) {
                        const firstIndex_whichMeetCondition = this.$store.state.manualHome.suffixSelection.findIndex(i => i.selected == true);
                        if (firstIndex_whichMeetCondition > -1) {
                            return this.$store.state.manualHome.suffixSelection[firstIndex_whichMeetCondition].value;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    var suffix = null;
                    for (let i = 0; i < this.$store.state.manualHome.suffixSelection.length; i++) {
                        this.$store.state.manualHome.suffixSelection[i].selected = false;
                        if (this.$store.state.manualHome.suffixSelection[i].value == value || (value == '' && this.$store.state.manualHome.suffixSelection[i].value == null)) {
                            this.$store.state.manualHome.suffixSelection[i].selected = true;
                            suffix = this.$store.state.manualHome.suffixSelection[i]
                        }
                    }
                    this.$store.dispatch('manualHome/change_suffix_storeAction', suffix)
                }
            },

            calculationNumber: {
                get() {
                    return this.calculation_Number;
                },
                set(value) {
                    this.change_calculationNumber(value);
                }
            },
            atkonfNumber: {
                get() {
                    return this.atkonf_Number;
                },
                set(value) {
                    this.change_atkonfNumber(value);
                }
            },
            itemNumber: {
                get() {
                    return this.item_Number;
                },
                set(value) {
                    this.change_itemNumber(value);
                }
            },
            documentNumber: {
                get() {
                    return this.document_Number;
                },
                set(value) {
                    this.change_documentNumber(value);
                }
            },

            atkonfSelection: {
                get() {
                    return this.$store.state.manualHome.atkonfSelection;
                }
            },
            loaderExistingConfigurations: {
                get() {
                    return this.$store.state.manualHome.loaderExistingConfigurations;
                },
            },
            fileLanguage: {
                get() {
                    return this.$store.state.summary.fileLanguage;
                },
                set(value) {
                    this.$store.dispatch('summary/change_fileLanguage_storeAction', value)
                }
            },
            showUnit: {
                get() {
                    if (this.$store.state.inputs.showUnit != null && this.$store.state.inputs.factorUnits != null) {
                        return this.$store.state.inputs.showUnit;
                    }
                    return false;
                }
            },
            showFileDownload: {
                get() {
                    if (this.zlwNumber != null && this.zlwNumber.length > 4 && this.zlwNumber.substring(0, 4).toLowerCase() === 'zlw-') {
                        return true;
                    }
                    return false;
                }
            },

            motorAvailable: {
                get() {
                    return (this.$store.state.inputsManual.motorManualData != null && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details') && this.$store.state.inputsManual.motorManualData.details.hasOwnProperty('mN_MOT')) &&
                            (this.$store.state.inputsManual.motorCablesManualData != null && this.$store.state.inputsManual.motorCablesManualData.hasOwnProperty('details')) &&
                            (this.$store.state.inputsManual.motorSuppliesManualData != null && this.$store.state.inputsManual.motorSuppliesManualData.hasOwnProperty('details')) &&
                            (this.$store.state.inputsManual.motorPackagingManualData != null && this.$store.state.inputsManual.motorPackagingManualData.hasOwnProperty('details')) ? true : false;
                }
            },
            frameAvailable: {
                get() {
                    return (this.$store.state.inputsManual.frameManualData != null && this.$store.state.inputsManual.frameManualData.hasOwnProperty('details') && this.$store.state.inputsManual.frameManualData.details.fratyp!=null) ? true : false;
                }
            },
            inverterAvailable: {
                get() {
                    return (this.$store.state.FI.FI_ModelUI_selected != null) ? true : false;
                }
            },
            evakAvailable: {
                get() {
                    return (this.$store.state.EVAC.EVAC_TypUI_select != null) ? true : false;
                }
            },
            recuperationAvailable: {
                get() {
                    return (this.$store.state.ZArec.ZArec_TypUI_select != null || this.$store.state.ZArec.RLD_TypUI_select != null) ? true : false;
                }
            },
            checkMotor: {
                get() {
                    if (this.check_Motor == null && this.motorAvailable == true) {
                        return true;
                    }
                    else {
                        return (this.check_Motor != null) ? this.check_Motor : false;
                    }
                },
                set(value) {
                    this.check_Motor = value;
                }
            },
            checkFrame: {
                get() {
                    if (this.check_Frame == null && this.frameAvailable == true) {
                        return true;
                    }
                    else {
                        return (this.check_Frame != null) ? this.check_Frame : false;
                    }
                },
                set(value) {
                    this.check_Frame = value;
                }
            },
            checkInverter: {
                get() {
                    if (this.check_Inverter == null && this.inverterAvailable == true) {
                        return true;
                    }
                    else {
                        return (this.check_Inverter != null) ? this.check_Inverter : false;
                    }
                },
                set(value) {
                    this.check_Inverter = value;
                }
            },
            checkEvak: {
                get() {
                    if (this.check_Evak == null && this.evakAvailable == true) {
                        return true;
                    }
                    else {
                        return (this.check_Evak != null) ? this.check_Evak : false;
                    }
                },
                set(value) {
                    this.check_Evak = value;
                }
            },
            checkRecuperation: {
                get() {
                    if (this.check_Recuperation == null && this.recuperationAvailable == true) {
                        return true;
                    }
                    else {
                        return (this.check_Recuperation != null) ? this.check_Recuperation : false;
                    }
                },
                set(value) {
                    this.check_Recuperation = value;
                }
            },
            request_offer_or_post_sap_available: {
                get() {
                    return (this.checkMotor == true || this.checkFrame == true || this.checkInverter == true || this.checkEvak == true || this.checkRecuperation == true) ? true : false;
                }
            },
        },
        created() {
        },
        methods: {

            check_configuration_fromFile(event) {
                const data = {
                    fileInformations: event.target.files[0],
                    fileLanguage: this.$store.state.configurations.language,
                    mode: 'manual'
                }
                event.target.value = null;
                this.$store.dispatch('configurations/check_configuration_fromFile_storeAction', data)
            },
            change_scrollYPosision() {
                this.scrollYPosition = window.scrollY;
            },
            search_configurationNumber() {
                this.$store.dispatch('manualHome/check_configuration_storeAction', this.configuration_Number);
            },
            zlmTemplate() {
                this.$store.dispatch('manualHome/check_configurationManualTemplate_storeAction');
                this.configuration_Number = null;
                this.$store.commit('manualHome/change_technicalConfiguration_storeMutation', false);
            },
            get_htmlFileContent() {
                const data = {
                    configurationOverviewsManualId: this.$store.state.manualHome.configurationOverviewsManualId,
                };
                this.$store.dispatch('summary/get_htmlFileContent_storeAction', data);
            },
            get_ZlwCalculation() {
                this.$store.dispatch('manualHome/change_showModalZlw_storeAction', true);
            },
            get_newVersionZlwCalculation() {
                this.$store.dispatch('inputsManual/get_newVersionZlwCalculation_storeAction');
            },
            closeModalZlw(value) {
                if (value == false) {
                    this.$store.dispatch('manualHome/change_showModalZlw_storeAction', false);
                }
                else {
                    this.$store.dispatch('manualHome/change_showModalZlw_storeAction', false);
                }
            },
            change_calculationNumber(value) {
                this.calculation_Number = value;
                if (this.change_calculationNumber != null) {
                    this.atkonf_Number = null;
                    this.item_Number = null;
                    this.document_Number = null;
                }
            },
            change_atkonfNumber(value) {
                this.atkonf_Number = value;
                if (this.atkonf_Number != null) {
                    this.calculation_Number = null;
                    this.item_Number = null;
                    this.document_Number = null;
                }
            },
            change_itemNumber(value) {
                this.item_Number = value;
                if (this.item_Number != null) {
                    this.atkonf_Number = null;
                    this.calculation_Number = null;
                    this.document_Number = null;
                }
            },
            change_documentNumber(value) {
                this.document_Number = value;
                if (this.document_Number != null) {
                    this.atkonf_Number = null;
                    this.item_Number = null;
                    this.calculation_Number = null;
                }
            },
            searchCalculation() {
                if (this.calculation_Number != null ||
                    this.atkonf_Number != null ||
                    this.item_Number != null ||
                    this.document_Number != null) {
                    const data = {
                        calculationNumber: this.calculation_Number,
                        atkonfNumber: this.atkonf_Number,
                        itemNumber: this.item_Number,
                        documentNumber: this.document_Number,
                    }
                    this.$store.dispatch('manualHome/check_existingConfigurations_storeAction', data);
                    this.calculationInformation = true;
                }
            },
            change_calculationModifiable() {
                if ((this.$store.state.inputsManual.motorManualData != null && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details') && this.$store.state.inputsManual.motorManualData.details.hasOwnProperty('mN_MOT')) && this.motorAvailable == false) {
                    const message = confirm(this.$t('3609'));
                    if (message) {
                        this.$store.dispatch('manualHome/change_calculationModifiable_storeAction');
                    }
                }
                else {
                    this.$store.dispatch('manualHome/change_calculationModifiable_storeAction');
                }
                 
            },
            change_showInfo() {
            },
            request_offer_or_post_order(type) {

            },
            request_offer_or_post_order_sap(type) {
                const data = {
                    type: type,
                    motor: this.checkMotor,
                    frame: this.checkFrame,
                    inverter: this.checkInverter,
                    evak: this.checkEvak,
                    recuperation: this.checkRecuperation,
                }
                this.$store.dispatch('inputsManual/request_offer_or_post_order_sap_storeAction', data)

            },
            request_Quotation_or_post_Quotation_sap(type) {
                const data = {
                    type: type,
                    motor: this.checkMotor,
                    frame: this.checkFrame,
                    inverter: this.checkInverter,
                    evak: this.checkEvak,
                    recuperation: this.checkRecuperation,
                }
                this.$store.dispatch('inputsManual/request_Quotation_or_post_Quotation_sap_storeAction', data)
            },
            request_Inquiry_or_post_Inquiry_sap(type) {
                const data = {
                    type: type,
                    motor: this.checkMotor,
                    frame: this.checkFrame,
                    inverter: this.checkInverter,
                    evak: this.checkEvak,
                    recuperation: this.checkRecuperation,
                }
                this.$store.dispatch('inputsManual/request_Inquiry_or_post_Inquiry_sap_storeAction', data)
            },
            rowClick(value, event) {
                this.$store.dispatch('manualHome/get_atkonfInformation_storeAction', value);
            },
            changeModalOffer() {
                this.$store.dispatch('summary/get_pi_manual_storeAction',this.inputCust);
            },
        }
    }</script>

<style>
    .modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: scroll;
        /*        height: 120%;*/
    }

    .modal-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 650px;
    }

    .modal-container {
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        max-width: 500px;
        width: 100%;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

        .modal-header h3 {
            margin: 0;
        }

    .modal-body {
        margin-bottom: 20px;
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
    }

    .my_text_selection_prevent {
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
